module.exports = pdfmake/build/pdfmake;